import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/homepage/how-it-works.jpg")